(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.ZayroBuyNowInitialized) return;
  window.ZayroBuyNowInitialized = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-zayro-buy-now]');
    if (!button || button.disabled) return;

    const form = button.closest('form');
    const addButton = form?.querySelector('.add-to-cart-button');
    if (!form || !form.reportValidity() || addButton?.disabled || addButton?.getAttribute('aria-disabled') === 'true') return;

    const formData = new FormData(form);
    if (!formData.get('id')) return;

    const originalText = button.textContent;
    const root = window.Shopify?.routes?.root || '/';
    button.disabled = true;
    button.textContent = button.dataset.loadingText;

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('cart/add.js failed');
      window.location.assign(`${root}checkout`);
    } catch (error) {
      button.disabled = false;
      button.textContent = originalText;
      const status = form.closest('product-form-component')?.querySelector('[ref="liveRegion"]');
      if (status) status.textContent = button.dataset.errorText;
      console.error('Zayro buy now:', error);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
